module.exports = __webpack_public_path__ + "static/media/1004095.9f187049.png";